/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import {ADD_TOAST, EMPTY_TOASTER} from 'state/toast/ToastActions';

export const toasterInitialState = {};

export const toasterReducer = (state = toasterInitialState, action) => {
  if (action.type === EMPTY_TOASTER || action.type === '@@router/LOCATION_CHANGE') {
    return toasterInitialState;
  }

  if (action.type === ADD_TOAST) {
    return {
      title: action.title,
      success: action.success,
      message: action.message
    };
  }

  return state;
};
